function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTileWxWinter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128.69 128.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128.69,
    height: 128.69,
    rx: 17.64,
    style: {
      fill: "#003173"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.35,115.54a3.61,3.61,0,0,1-3.6-3.61V99l-6.28,4.66a3.62,3.62,0,0,1-2.13.7,3.57,3.57,0,0,1-2.9-1.46,3.61,3.61,0,0,1,.76-5l10.55-7.84V70.58L43.89,80.32,42.37,93.37a3.59,3.59,0,0,1-3.57,3.2l-.41,0a3.62,3.62,0,0,1-3.18-4l.9-7.76L24.93,91.26A3.6,3.6,0,0,1,20,89.94,3.61,3.61,0,0,1,21.33,85l11.18-6.45-7.17-3.1a3.6,3.6,0,0,1,1.44-6.9,3.57,3.57,0,0,1,1.44.3l12.07,5.21,16.86-9.73L40.29,54.61,28.22,59.83A3.6,3.6,0,0,1,23.48,58a3.62,3.62,0,0,1,1.86-4.74l7.17-3.1L21.33,43.67A3.6,3.6,0,0,1,23.14,37a3.52,3.52,0,0,1,1.79.49l11.18,6.45-.9-7.76a3.61,3.61,0,0,1,3.18-4,2.73,2.73,0,0,1,.41,0,3.6,3.6,0,0,1,3.57,3.2l1.52,13.06,16.86,9.73V38.64L50.2,30.8A3.6,3.6,0,0,1,54.48,25l6.27,4.66V16.76a3.6,3.6,0,0,1,7.2,0V29.67L74.22,25a3.61,3.61,0,0,1,5,.75,3.61,3.61,0,0,1-.75,5L68,38.64V58.11l16.86-9.73,1.51-13.06a3.61,3.61,0,0,1,3.58-3.2l.41,0a3.6,3.6,0,0,1,3.17,4l-.9,7.76,11.18-6.45a3.57,3.57,0,0,1,1.79-.49,3.63,3.63,0,0,1,3.13,1.8,3.6,3.6,0,0,1-1.32,4.92L96.18,50.12l7.17,3.11a3.6,3.6,0,0,1-1.44,6.9,3.53,3.53,0,0,1-1.43-.3L88.41,54.61,71.55,64.35l16.86,9.73,12.06-5.21a3.6,3.6,0,1,1,2.88,6.6l-7.17,3.1L107.36,85a3.6,3.6,0,0,1-1.8,6.72,3.64,3.64,0,0,1-1.8-.48L92.58,84.8l.9,7.77a3.61,3.61,0,0,1-3.17,4l-.41,0a3.6,3.6,0,0,1-3.58-3.19L84.81,80.32,68,70.58V90.05L78.5,97.89a3.61,3.61,0,0,1,.75,5,3.59,3.59,0,0,1-5,.75L68,99v12.9A3.61,3.61,0,0,1,64.35,115.54Z",
    style: {
      fill: "#fff"
    }
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTileWxWinter);
export default __webpack_public_path__ + "static/media/tile_WXWinter.f1362f0fb5da974852563f034201db24.svg";
export { ForwardRef as ReactComponent };